var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"overflow-hidden"},[_c('v-app-bar',{attrs:{"dark":"","color":"primary"}},[_c('MainNav'),_c('AuthNav')],1)],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }